import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMPaymentMethodTypeAsync,
  deleteOMPaymentMethodTypeAsync,
  editOMPaymentMethodTypeAsync,
  getOMPaymentMethodTypeAsync,
} from "../../../store/services/orderManagementService";
const PaymentMethodType = () => {
  const dispatch = useDispatch();
  const {
    getOMPaymentMethodTypeStatus,
    getOMPaymentMethodTypeError,
    getOMPaymentMethodTypeData,
    addOMPaymentMethodTypeStatus,
    addOMPaymentMethodTypeData,
    addOMPaymentMethodTypeError,

    editOMPaymentMethodTypeStatus,
    editOMPaymentMethodTypeError,
    editOMPaymentMethodTypeData,

    deleteOMPaymentMethodTypeData,
    deleteOMPaymentMethodTypeStatus,
    deleteOMPaymentMethodTypeError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMPaymentMethodTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMPaymentMethodTypeData?.length
    ? getOMPaymentMethodTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedPaymentMethodType, setSelectedPaymentMethodType] = useState();
  const [addPaymentMethodTypeMode, setAddPaymentMethodTypeMode] = useState(false);
  const [addPaymentMethodTypeData, setAddPaymentMethodTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedPaymentMethodType", selectedPaymentMethodType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMPaymentMethodTypeStatus === asyncStatus.SUCCEEDED) {
      setAddPaymentMethodTypeMode(false);
      setSaveDisabled(true);
      setAddPaymentMethodTypeData();
    }
  }, [, addOMPaymentMethodTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMPaymentMethodTypeAsync(selectedPaymentMethodType?.method_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMPaymentMethodTypeStatus === asyncStatus.SUCCEEDED||deleteOMPaymentMethodTypeStatus === asyncStatus.ERROR) {
      setOpen(false);
      setSelectedPaymentMethodType();
    }
  }, [, deleteOMPaymentMethodTypeStatus]);
  useEffect(() => {
    if (editOMPaymentMethodTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedPaymentMethodType();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMPaymentMethodTypeStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this payment method type?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Payment Method Type"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Payment Method Type Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddPaymentMethodTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addPaymentMethodTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentMethodTypeMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddPaymentMethodTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentMethodTypeMode || !selectedPaymentMethodType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMPaymentMethodTypeStatus === asyncStatus.LOADING ||
                  editOMPaymentMethodTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addPaymentMethodTypeData) {
                    dispatch(addOMPaymentMethodTypeAsync(addPaymentMethodTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedPaymentMethodType, ...editData };
                    delete a.id;
                    dispatch(editOMPaymentMethodTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "method_type_id", headerName: "ID", flex: true },
                  { field: "method_type_name", headerName: "Payment Method Type", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedPaymentMethodType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMPaymentMethodTypeStatus === asyncStatus.IDLE ||
                  getOMPaymentMethodTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addPaymentMethodTypeMode ? (
              <InputWithBtnLayoutComp
              error={addOMPaymentMethodTypeError}
                inputArray={[
                  {
                    label: "Payment Method Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddPaymentMethodTypeData({
                            ...addPaymentMethodTypeData,
                            method_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddPaymentMethodTypeData({
                            ...addPaymentMethodTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedPaymentMethodType ? (
              <InputWithBtnLayoutComp
              error={editOMPaymentMethodTypeError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedPaymentMethodType?.method_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "PaymentMethodType:",
                    comp: (
                      <InputComp
                        key={selectedPaymentMethodType?.method_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            method_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedPaymentMethodType?.method_type_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedPaymentMethodType?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedPaymentMethodType?.is_active || editData?.is_active}
                        defaultChecked={selectedPaymentMethodType?.is_active || editData?.is_active}
                        // checked={selectedPaymentMethodType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Stack>
              <Typography>Select any payment method type</Typography>
              <Typography color={"red"} fontSize={12}>{getOMPaymentMethodTypeError}</Typography>
              </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedPaymentMethodType(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedPaymentMethodType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default PaymentMethodType;
